// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"e21f159b","433":"e857db10","765":"f3cc8e30","787":"9d220db8"}[chunkId] + ".chunk.js";
};